import React from 'react';

import { RedoOutlined } from '@ant-design/icons';

import { getEventTypeColor, getEventCategoryColor } from './../../../utils/color-utils';
import * as calendarConsts from './../../../constants/calendar-constants';
import './head-event.less';
import EventPopover from './event-popover';

const HeadEvent = (props) => {
  const { item, daysCount, onEditEvent, onDeleteEvent, rootContainer, calendarCategories } = props;

  const eventClassNames = ['head-event'];

  let width = 100;
  let left = 0;
  const minWidth = 13;

  if (item.continousStart) {
    eventClassNames.push('head-event-continous-start');
  }

  if (item.continousMiddle) {
    eventClassNames.push('head-event-continous-middle');
  }

  if (item.continousLast) {
    eventClassNames.push('head-event-continous-last');
  }

  if (item.diffFirstStart > 0 || item.diffLastEnd < 0) {
    let beforeStart = 0;
    let beforeEnd = 0;

    if (item.diffFirstStart > 0) {
      // beforeStart = Math.round(item.diffFirstStart/calendarConsts.MinutesInDay/ daysCount * 100);
      beforeStart = (item.diffFirstStart / calendarConsts.MinutesInDay / daysCount) * 100;
    }

    if (item.diffLastEnd < 0) {
      // beforeEnd = Math.round(-item.diffLastEnd / calendarConsts.MinutesInDay / daysCount * 100);
      beforeEnd = (-item.diffLastEnd / calendarConsts.MinutesInDay / daysCount) * 100;
    }

    const total = beforeEnd + beforeStart;
    if (total > 0 && total <= 100) {
      if (beforeStart > 0 && beforeStart <= 100) {
        left = beforeStart;
        width -= beforeStart;
      }

      if (beforeEnd > 0 && beforeEnd <= 100) {
        width -= beforeEnd;
      }

      if (width <= minWidth) {
        width = minWidth;
      }
    }
  }

  const itemBackgroundColor = getEventCategoryColor(calendarCategories, item);
  const mainBorderColor = getEventTypeColor(item);

  return (
    <EventPopover item={item} onEditEvent={onEditEvent} onDeleteEvent={onDeleteEvent} rootContainer={rootContainer}>
      <div
        style={{
          backgroundColor: itemBackgroundColor,
          borderColor: mainBorderColor,
          width: width + '%',
          left: left + '%',
        }}
        className={eventClassNames.join(' ')}
        onClick={($event) => {
          $event.preventDefault();
          $event.stopPropagation();
        }}
      >
        <span title={item.content}>
          {item.recurrenceObject && <RedoOutlined style={{ paddingRight: '2px' }} />}
          {item.content}
        </span>
      </div>
    </EventPopover>
  );
};

export default HeadEvent;
